import React, { useState, useEffect, useRef } from 'react';
import { API_URL } from '../../api';
import {
  Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  IconButton, Typography, Collapse, Button, Box, TextField, Grid, Dialog, DialogTitle, DialogContent
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import Tooltip from '@mui/material/Tooltip';
import KPI from './KPI';


const statusList = [
  'NÃO INICIADO', 'NAO INICIADO','EM DESENVOLVIMENTO', 'AMOSTRAS', 'COLETA DE ESTIMATIVAS',
  'CANCELADO', 'AGUARDANDO INF. COMERCIAL',
  'ORÇAMENTO NOVA PÁGINA', 'ORÇAMENTO DE FACA'
];

const formatarDataBR = (isoDate) => {
  if (!isoDate || typeof isoDate !== 'string') return '-';
  const [ano, mes, dia] = isoDate.split('-');
  if (!ano || !mes || !dia) return isoDate;
  return `${dia}/${mes}/${ano}`;
};

function TabelaGPD({ itens, onEditar, onAtualizar, usuario, onFiltrar }) {


  const formatarStatus = (status) => {
  const mapaStatus = {
    'NAO INICIADO': 'Não Iniciado',
    'EM DESENVOLVIMENTO': 'Em Desenvolvimento',
    'AMOSTRAS': 'Amostras',
    'COLETA DE ESTIMATIVAS': 'Coleta de Estimativas',
    'CANCELADO': 'Cancelado',
    'AGUARDANDO INF. COMERCIAL': 'Aguardando Inf. Comercial',
    'ORÇAMENTO NOVA PÁGINA': 'Orçamento Nova Página',
    'ORÇAMENTO DE FACA': 'Orçamento de Faca',
    'SEM STATUS': 'Sem Status'
  };

  return mapaStatus[status] || status;
};





  const isAdmin = Array.isArray(usuario?.tipo)
  ? usuario.tipo.map(t => t.toLowerCase()).includes('admin')
  : usuario?.tipo?.toLowerCase() === 'admin';

  const [expandedStatus, setExpandedStatus] = useState({});
  const [mostrarModalConcluidos, setMostrarModalConcluidos] = useState(false);
  const [mostrarKPI, setMostrarKPI] = useState(false);

  const [itensConcluidos, setItensConcluidos] = useState([]);

const [filtroIM, setFiltroIM] = useState('');
const [filtroCliente, setFiltroCliente] = useState('');
const [filtroProjeto, setFiltroProjeto] = useState('');

const [filtroIMConcluido, setFiltroIMConcluido] = useState('');
const [filtroClienteConcluido, setFiltroClienteConcluido] = useState('');
const [filtroProjetoConcluido, setFiltroProjetoConcluido] = useState('');


  const normalizarTexto = (texto) => {
    if (typeof texto !== 'string') return '';
    return texto.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^\x00-\x7F]/g, '').toUpperCase();
  };

  const toggleStatus = (status) => {
    setExpandedStatus(prev => ({ ...prev, [status]: !prev[status] }));
  };

  const handleExcluir = async (id) => {
    if (!window.confirm('Deseja realmente excluir este item?')) return;
    try {
      await axios.delete(`${API_URL}/gpd/itens/${id}`);
      alert('Item excluído com sucesso!');
      if (onAtualizar) onAtualizar();
    } catch (error) {
      alert('Erro ao excluir.');
    }
  };

const handleDuplicar = async (item) => {
  const duplicado = {
    ...item,
    id: Date.now(),
    im: item.im + '-C',

    // Arrays complexos: duplicação segura
    componentes: Array.isArray(item.componentes)
      ? JSON.stringify(item.componentes.map(c => ({ ...c })))
      : JSON.stringify([]),

    acabamento: Array.isArray(item.acabamento) ? [...item.acabamento] : [],

    categorias: Array.isArray(item.categorias) ? [...item.categorias] : [],

    // Histórico de alterações LIMPO
    historicoAlteracoes: [],
  };

  try {
    await axios.post(`${API_URL}/gpd/itens`, duplicado);
    alert('Item duplicado com sucesso!');
    if (onAtualizar) onAtualizar();
  } catch (error) {
    console.error('Erro ao duplicar:', error);
    alert('Erro ao duplicar.');
  }
};


const filtrar = (item) => {
  return (
    item.im?.toLowerCase().includes(filtroIM.toLowerCase()) &&
    item.cliente?.toLowerCase().includes(filtroCliente.toLowerCase()) &&
    item.projeto?.toLowerCase().includes(filtroProjeto.toLowerCase())
  );
};


useEffect(() => {
  const delayDebounce = setTimeout(() => {
    if (onFiltrar) {
      onFiltrar(filtroIM, filtroCliente, filtroProjeto);
    }
  }, 400);
  return () => clearTimeout(delayDebounce);
}, [filtroIM, filtroCliente, filtroProjeto]);


  const filtrarModal = (item) => {
    return (
      item.im?.toLowerCase().includes(filtroIMConcluido.toLowerCase()) &&
      item.cliente?.toLowerCase().includes(filtroClienteConcluido.toLowerCase()) &&
      item.projeto?.toLowerCase().includes(filtroProjetoConcluido.toLowerCase())
    );
  };

const carregarConcluidos = async () => {
  try {
    const res = await axios.get(`${API_URL}/gpd/itens-concluidos`, {
      params: {
        im: filtroIMConcluido,
        cliente: filtroClienteConcluido,
        projeto: filtroProjetoConcluido
      }
    });
    setItensConcluidos(res.data);
  } catch (err) {
    alert('Erro ao carregar itens concluídos');
    console.error('Erro ao carregar concluídos:', err);
  }
};



  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>Registros Cadastrados (GPD)</Typography>





<Grid container spacing={2} sx={{ mb: 2 }}>
  <Grid item xs={12} sm={4}>
    <TextField
      label="Filtrar por IM"
      fullWidth
      value={filtroIM}
      onChange={(e) => setFiltroIM(e.target.value)}
    />
  </Grid>
  <Grid item xs={12} sm={4}>
    <TextField
      label="Filtrar por Cliente"
      fullWidth
      value={filtroCliente}
      onChange={(e) => setFiltroCliente(e.target.value)}
    />
  </Grid>
  <Grid item xs={12} sm={4}>
    <TextField
      label="Filtrar por Projeto"
      fullWidth
      value={filtroProjeto}
      onChange={(e) => setFiltroProjeto(e.target.value)}
    />
  </Grid>
  <Grid item xs={12}>
    <Button
      variant="contained"
      color="success"
      fullWidth
      sx={{ my: 1 }}
      onClick={() => setMostrarModalConcluidos(true)}
    >
      Visualizar Itens Concluídos
    </Button>
  </Grid>
</Grid>







<Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
  <Button variant="outlined" color="secondary" size="small" onClick={() => {
    const novos = {};
    Object.keys(expandedStatus).forEach(status => { novos[status] = false; });
    setExpandedStatus(novos);
  }}>
    Recolher Todos
  </Button>

  <Button variant="outlined" color="primary" size="small" onClick={() => {
    const novos = {};
    Object.keys(expandedStatus).forEach(status => { novos[status] = true; });
    setExpandedStatus(novos);
  }}>
    Expandir Todos
  </Button>


    <Button variant="outlined" color="info" size="small" onClick={() => setMostrarKPI(true)}>
    Indicadores (KPI)
  </Button>

</Box>





{(() => {
  const agrupadosPorStatus = {};

itens
  .filter(filtrar) // aplica o filtro antes de agrupar
  .forEach(item => {
    const status = normalizarTexto(item.status || 'SEM STATUS');

    if (
      status === 'CONCLUIDO' ||
      status === 'CANCELADO' ||
      status.includes('PRE-ORCAMENTO') || status.includes('PRÉ-ORÇAMENTO')
    ) return;

    if (!agrupadosPorStatus[status]) agrupadosPorStatus[status] = [];
    agrupadosPorStatus[status].push(item);
  });


  return Object.keys(agrupadosPorStatus).sort().map(status => (
    <Box key={status} sx={{ mb: 2 }}>
      <Button
        onClick={() => toggleStatus(status)}
        variant="contained"
        fullWidth
        sx={{
          textAlign: 'left',
          justifyContent: 'space-between',
          fontWeight: 'bold',
          fontSize: 16,
          backgroundColor: expandedStatus[status] ? '#1565c0' : '#bbdefb',
          color: expandedStatus[status] ? '#fff' : '#0d47a1',
          '&:hover': { backgroundColor: expandedStatus[status] ? '#0d47a1' : '#90caf9' },
        }}
        endIcon={expandedStatus[status] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      >
        {formatarStatus(status)} ({agrupadosPorStatus[status].length})

      </Button>

      <Collapse in={expandedStatus[status]}>
        <TableContainer sx={{ mt: 1 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell><b>IM</b></TableCell>
                <TableCell><b>Cliente</b></TableCell>
                <TableCell sx={{ maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  <b>Projeto</b>
                </TableCell>
                <TableCell><b>Descrição</b></TableCell>
                <TableCell><b>Responsável</b></TableCell>
                <TableCell><b>Data Início</b></TableCell>
                <TableCell><b>Data Entrega</b></TableCell>
                <TableCell><b>Ações</b></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {agrupadosPorStatus[status].filter(filtrar).map((item) => (
                <TableRow key={item.id} hover sx={{ cursor: 'pointer' }} 
                
                
                onClick={(e) => {
  if (e.target.closest('button')) return;

  const componentesNormalizados = (item.componentes || []).map((comp) => ({
    descricaoItem: '',
    materiaPrima: '',
    codigoCliente: '',
    cores: [],
    demanda: '',
    micro: '',
    acabamentos: [],
    impressao: '',
    quantidadeImpressao: '',
    mostrarAcabamentos: false,
    ...comp
  }));

  onEditar({
    ...item,
    componentes: componentesNormalizados
  });
}}

                
                
                >
                  <TableCell>{`${item.im}${item.subconjunto || ''}`}</TableCell>
                  <TableCell>{item.cliente}</TableCell>




                  <TableCell sx={{ maxWidth: 240, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {item.projeto}
                  </TableCell>
                  <TableCell>
{(item.componentes || []).some(comp => comp.descricaoItem) && (
  <Tooltip
    title={
      <Box>
        {(item.componentes || []).map((comp, index) =>
          comp.descricaoItem ? (
            <Typography key={index} variant="body2">{comp.descricaoItem}</Typography>
          ) : null
        )}
      </Box>
    }
    arrow
    placement="bottom-start"
  >
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        padding: '2px 10px',
        border: '1px solid #1976d2',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#0d47a1',
        cursor: 'pointer',
        userSelect: 'none',
        textTransform: 'uppercase',
        textAlign: 'center',
        '&:hover': {
          backgroundColor: '#e3f2fd'
        }
      }}
    >
      descrição
    </Box>
  </Tooltip>
)}


                  </TableCell>
                  <TableCell>{item.responsavel}</TableCell>






                  <TableCell>{formatarDataBR(item.dataInicio)}</TableCell>
                  <TableCell>{formatarDataBR(item.dataEntrega)}</TableCell>
                  <TableCell>
                    {isAdmin && (
                      <>
                        <Tooltip title="Marcar CONCLUÍDO">
                          <IconButton color="success" onClick={async () => {
                            try {
                              await axios.put(`${API_URL}/gpd/itens/${item.id}`, {
                                ...item,
                                status: 'CONCLUÍDO',
                                historicoAlteracoes: [
                                  ...(item.historicoAlteracoes || []),
                                  {
                                    data: new Date().toISOString(),
                                    acao: 'Concluído via botão',
                                    por: localStorage.getItem('usuario') || 'desconhecido'
                                  }
                                ]
                              });
                              alert('Item marcado como CONCLUÍDO!');
                              if (onAtualizar) onAtualizar();
                            } catch (err) {
                              alert('Erro ao atualizar status.');
                            }
                          }}>
                            ✅
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Duplicar cadastro">
                          <IconButton color="warning" onClick={() => handleDuplicar(item)}>
                            <ContentCopyIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Excluir cadastro">
                          <IconButton color="error" onClick={() => handleExcluir(item.id)}>
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Collapse>
    </Box>
  ));
})()}





      <Dialog
  open={mostrarModalConcluidos}
  onClose={() => {
    setMostrarModalConcluidos(false);
    setFiltroIMConcluido('');
    setFiltroClienteConcluido('');
    setFiltroProjetoConcluido('');
    setItensConcluidos([]);
  }}
  maxWidth="xl"
  fullWidth
>

        <DialogTitle sx={{ mb: 4, fontWeight: 'bold' }}>
          Itens com Status CONCLUÍDO
        </DialogTitle>

        <DialogContent>


<Grid container spacing={2} sx={{ mb: 3 }}>
  <Grid item xs={4}>
    <TextField
      label="Filtrar por IM"
      fullWidth
      value={filtroIMConcluido}
      onChange={(e) => setFiltroIMConcluido(e.target.value)}
    />
  </Grid>
  <Grid item xs={4}>
    <TextField
      label="Filtrar por Cliente"
      fullWidth
      value={filtroClienteConcluido}
      onChange={(e) => setFiltroClienteConcluido(e.target.value)}
    />
  </Grid>
  <Grid item xs={4}>
    <TextField
      label="Filtrar por Projeto"
      fullWidth
      value={filtroProjetoConcluido}
      onChange={(e) => setFiltroProjetoConcluido(e.target.value)}
    />
  </Grid>

  <Grid item xs={12} sm={4}>
    <Button
      variant="contained"
      color="primary"
      fullWidth
      onClick={carregarConcluidos}
    >
      Aplicar Filtros
    </Button>
  </Grid>
<Grid item xs={12} sm={4}>
  <Button
    variant="outlined"
    color="secondary"
    fullWidth
    onClick={() => {
      setFiltroIMConcluido('');
      setFiltroClienteConcluido('');
      setFiltroProjetoConcluido('');
      setItensConcluidos([]); // 🔁 esvazia visualmente
    }}
  >
    Limpar Filtros
  </Button>
</Grid>

  <Grid item xs={12} sm={4}>
    <Button
      variant="outlined"
      color="success"
      fullWidth
      onClick={async () => {
        setFiltroIMConcluido('');
        setFiltroClienteConcluido('');
        setFiltroProjetoConcluido('');
        await carregarConcluidos();
      }}
    >
      Mostrar Todos
    </Button>
  </Grid>
</Grid>



<Typography variant="subtitle1" sx={{ mb: 1 }}>
  {`Exibindo ${itensConcluidos.filter(filtrarModal).length} de ${itensConcluidos.length} itens concluídos`}
</Typography>





<TableContainer>
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell><b>IM</b></TableCell>
        <TableCell><b>Cliente</b></TableCell>
<TableCell><b>Projeto</b></TableCell>
<TableCell><b>Responsável</b></TableCell>

        <TableCell><b>Data Início</b></TableCell>
        <TableCell><b>Data Entrega</b></TableCell>
        <TableCell><b>Ações</b></TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {itensConcluidos.filter(filtrarModal).map((item) => (
        <TableRow key={item.id} hover sx={{ cursor: 'pointer' }} 
        
        onClick={(e) => {
  if (e.target.closest('button')) return;

  const componentesNormalizados = (item.componentes || []).map((comp) => ({
    descricaoItem: '',
    materiaPrima: '',
    codigoCliente: '',
    cores: [],
    demanda: '',
    micro: '',
    acabamentos: [],
    impressao: '',
    quantidadeImpressao: '',
    mostrarAcabamentos: false,
    ...comp
  }));

  onEditar({
    ...item,
    componentes: componentesNormalizados
  });
}}

        
        
        >
          <TableCell>{`${item.im}${item.subconjunto || ''}`}</TableCell>
          <TableCell>{item.cliente}</TableCell>
          <TableCell sx={{ maxWidth: 200, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
  {item.projeto}
</TableCell>

          <TableCell>{item.responsavel}</TableCell>
<TableCell>{formatarDataBR(item.dataInicio)}</TableCell>
<TableCell>{formatarDataBR(item.dataEntrega)}</TableCell>

          <TableCell>
            {isAdmin && (
              <>
                <Tooltip title="Duplicar cadastro">
                  <IconButton color="warning" onClick={() => handleDuplicar(item)}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Excluir cadastro">
                  <IconButton color="error" onClick={() => handleExcluir(item.id)}>
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </>
            )}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
</TableContainer>



        </DialogContent>
      </Dialog>

<KPI open={mostrarKPI} onClose={() => setMostrarKPI(false)} />


    </Paper>
  );
}

export default TabelaGPD;
